/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ScannedIdentificationCodeType {
  None = 'None',
  SsccCode = 'SsccCode',
  ExternalSerialId = 'ExternalSerialId'
}
